import clsx from 'clsx';

import { AnimateModal, ModalOpenProps } from '@/components/ui/modal';
import { NEW_DUCT_LENGTH_TITLE, SELECT_DUCT_SYSTEM } from '@/config';

import { useDuctLength } from '../hooks/useDuctLength';
import { useNormalView } from '../hooks/useNormalView';
import { ShapeSelect, DuctDynaFields, CreateMoreSystems } from '../inputs';
import { CATALOGUE_CATEGORY, TKSystem, LENGTH_TYPE } from '../types';

type DuctLenthProps = ModalOpenProps & {
  /**
   * LENGTH_TYPE.D
   */
  selectType: string;
  systems: TKSystem[];
  unit?: string;
};

/** Create New Duct Length Modal */
export const AddDuctLength = ({
  isOpen,
  isOnStage,
  systems,
  unit,
  selectType,
  lazyCloseHandler,
}: DuctLenthProps) => {
  const {
    systemType,
    shapeType,
    fieldProps,
    ductLengthFields,
    inputFieldRenderer,
    setSystemType,
    shapeChangeHandler,
    applyNewElementHandler,
    cancelNewElementHandler,
  } = useDuctLength(lazyCloseHandler);

  const { isNormalView, setIsNormalView, normalView } = useNormalView();

  return (
    <AnimateModal
      isOpen={isOpen}
      isOnStage={isOnStage}
      lazyCloseHandler={lazyCloseHandler}
      title={isNormalView ? NEW_DUCT_LENGTH_TITLE : SELECT_DUCT_SYSTEM}
    >
      {/* == system field == */}
      <CreateMoreSystems
        systems={systems}
        category={CATALOGUE_CATEGORY.D}
        itemType={selectType}
        currentSystem={systemType}
        currentSystemChangeHandler={setSystemType}
        onMoreSystemSwitch={setIsNormalView}
      />
      {/* use shape radio group if necessary */}
      <>
        {isNormalView && (
          <ShapeSelect shapeType={shapeType} onChange={shapeChangeHandler} />
        )}
      </>
      {/* == make fields dynamic rendered by definition @2025/04/22 */}
      <div className={normalView('flex flex-wrap my-0 gap-0')}>
        <DuctDynaFields
          defaultValues={fieldProps}
          fields={ductLengthFields}
          fieldRenderer={inputFieldRenderer}
          unit={unit}
          itemType={LENGTH_TYPE.D}
        />
      </div>
      {/* button row */}
      <div className="flex gap-x-10 justify-between mx-0 mt-6">
        {/* close modal */}
        <button
          className="btn-red-border color-red font-semibold flex-1 red-shadow"
          onClick={cancelNewElementHandler}
        >
          Cancel
        </button>
        {/* save button */}
        <button
          className={clsx(
            'btn-green flex-1 leading-5 text-base bg-green shadow-md',
          )}
          onClick={applyNewElementHandler}
        >
          Apply
        </button>
      </div>
    </AnimateModal>
  );
};
